class CollectionsMarquee extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('.collections-marquee__track');
    this.list = this.querySelector('.collections-marquee__list:not(.collections-marquee__list--duplicate)');
    this.speed = parseFloat(this.dataset.speed) || 50;
  }

  connectedCallback() {
    if (!this.track || !this.list) return;

    this.querySelectorAll('.collections-marquee__list--duplicate a, .collections-marquee__list--duplicate button').forEach(
      (element) => element.setAttribute('tabindex', '-1')
    );

    this.updateDuration();

    if (!this.resizeObserver) {
      this.resizeObserver = new ResizeObserver(() => this.updateDuration());
      this.resizeObserver.observe(this);
    }
  }

  updateDuration() {
    if (!this.track || !this.list) return;

    const listWidth = this.list.getBoundingClientRect().width;
    if (!listWidth) return;

    const duration = listWidth / this.speed;
    this.style.setProperty('--marquee-duration', `${duration}s`);
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }
}

customElements.define('collections-marquee', CollectionsMarquee);
